import * as React from "react";
import {
    ANNUAL_MOTOR_ADDRESS_CHANGE_LIMIT,
    ANNUAL_MOTOR_ADD_DRIVER_LIMIT,
    ANNUAL_MOTOR_REPLACE_CAR_LIMIT,
    ANNUAL_MOTOR_TOTAL_MTA_LIMIT,
    ANNUAL_MOTOR_VRN_CHANGE_LIMIT
} from "@falcon/services";
import { WarningBanner } from "./WarningBanner";

interface IProps {
    interaction: any;
}

export class MtaLimitWarningBanner extends React.Component<IProps> {

    public render(): React.ReactNode {
        const factors: any = this.props.interaction.factors;
        const banners: React.ReactNode[] = [];

        this.addTotalMtaBanner(banners, factors.totalMtaCount);
        this.addCarReplacementBanner(banners, factors.changeOfVehicleCount);
        this.addVrnChangeBanner(banners, factors.registrationNumberChangeCount);
        this.addAddressChangeBanner(banners, factors.addressChangeCount);
        this.addAdditionalDriverBanner(banners, this.props.interaction.additionalDrivers);

        return <>
            {banners}
        </>
    }

    private addTotalMtaBanner(banners: React.ReactNode[], mtaCount: number): void {
        if (mtaCount === ANNUAL_MOTOR_TOTAL_MTA_LIMIT - 1) {
            const wording: string = "Heads up - you’ve already made 7 changes to your policy this year. " +
                "You will only be able to make one more change to your policy before your next renewal.";

            banners.push(
                <WarningBanner wording={wording}/>
            )
        } else if (mtaCount === ANNUAL_MOTOR_TOTAL_MTA_LIMIT) {
            const wording: string = "Heads up - you’ve already made 8 changes to your policy this year. " +
                "We will no longer be able to insure you if you wish to make further changes to your policy before your next renewal.";

            banners.push(
                <WarningBanner wording={wording}/>
            )
        }
    }

    private addCarReplacementBanner(banners: React.ReactNode[], changeOfVehicleCount: number): void {
        if (changeOfVehicleCount === ANNUAL_MOTOR_REPLACE_CAR_LIMIT - 1) {
            const wording: string = "Heads up - you’ve changed your car 3 times this policy year, " +
                "so you’ll only be able to change it again one more time before your next renewal.";

            banners.push(
                <WarningBanner wording={wording}/>
            )
        } else if (changeOfVehicleCount === ANNUAL_MOTOR_REPLACE_CAR_LIMIT) {
            const wording: string = "Heads up - you’ve changed your car 4 times this policy year. " +
                "We will no longer be able to insure you if you wish to replace your vehicle again before your next renewal.";

            banners.push(
                <WarningBanner wording={wording}/>
            )
        }
    }

    private addVrnChangeBanner(banners: React.ReactNode[], vrnChangeCount: number): void {
        if (vrnChangeCount === ANNUAL_MOTOR_VRN_CHANGE_LIMIT - 1) {
            const wording: string = "Heads up - you've changed your vehicle registration number once already this policy year, " +
                "so you’ll only be able to change it one more time before your next renewal.";

            banners.push(
                <WarningBanner wording={wording}/>
            )
        } else if (vrnChangeCount === ANNUAL_MOTOR_VRN_CHANGE_LIMIT) {
            const wording: string = "Heads up - you’ve changed your vehicle registration number twice this policy year. " +
                "We will no longer be able to insure you if you wish to change your registration number again before your next renewal.";

            banners.push(
                <WarningBanner wording={wording}/>
            )
        }
    }

    private addAddressChangeBanner(banners: React.ReactNode[], addressChangeCount: number): void {
        if (addressChangeCount === ANNUAL_MOTOR_ADDRESS_CHANGE_LIMIT - 1) {
            const wording: string = "Heads up - you've changed your address once already this policy year, " +
                "so you’ll only be able to change it again one more time before your next renewal.";

            banners.push(
                <WarningBanner wording={wording}/>
            )
        } else if (addressChangeCount === ANNUAL_MOTOR_ADDRESS_CHANGE_LIMIT) {
            const wording: string = "Heads up - you’ve changed your address twice this policy year. " +
                "We will no longer be able to insure you if you wish to change your address again before your renewal date.";

            banners.push(
                <WarningBanner wording={wording}/>
            )
        }
    }

    private addAdditionalDriverBanner(banners: React.ReactNode[], additionalDrivers: any[]): void {
        for (const additionalDriver of additionalDrivers) {
            const firstName: string = additionalDriver.firstName;
            const lastName: string = additionalDriver.lastName;

            if (additionalDriver.timesAddedToPolicy === ANNUAL_MOTOR_ADD_DRIVER_LIMIT - 1) {
                const wording: string = `Heads up - you’ve added ${firstName} ${lastName} to your policy 3 times this policy year, ` +
                    `so if you remove ${firstName} ${lastName} from the policy, you will only be able to add the same driver back once more before your next renewal.`;

                banners.push(
                    <WarningBanner wording={wording}/>
                )
            } else if (additionalDriver.timesAddedToPolicy === ANNUAL_MOTOR_ADD_DRIVER_LIMIT) {
                const wording: string = `Heads up - you’ve added ${firstName} ${lastName} to your policy 4 times this policy year. ` +
                    `If you remove ${firstName} ${lastName} from the policy, you will not be able to add them again before your next renewal.`;

                banners.push(
                    <WarningBanner wording={wording}/>
                )
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/banners/MtaLimitWarningBanner.tsx